import { render, staticRenderFns } from "./formulir-ls.vue?vue&type=template&id=ff7dbede"
import script from "./formulir-ls.vue?vue&type=script&lang=js"
export * from "./formulir-ls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports